
import React from "react";
import { Button } from "@/components/ui/button";
import { Copy } from "lucide-react";
import { InventoryItem } from "@/types/inventory";
import { copyBasicProductDetails, copyAllProductDetails } from "@/utils/clipboard";

interface ActionButtonsProps {
  item: InventoryItem;
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({ item }) => {
  return (
    <div className="space-x-2">
      <Button 
        variant="copy"
        size="xs"
        className="flex items-center gap-1"
        onClick={() => copyBasicProductDetails(item)}
      >
        <Copy className="h-3 w-3" />
        <span className="whitespace-nowrap">Kopieer basis</span>
      </Button>
      <Button 
        variant="secondary"
        size="xs"
        className="flex items-center gap-1 mt-1"
        onClick={() => copyAllProductDetails(item)}
      >
        <Copy className="h-3 w-3" />
        <span className="whitespace-nowrap">Kopieer alles</span>
      </Button>
    </div>
  );
};
